var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    d: "M12.348 5.58254C10.3909 3.29448 7.12721 2.679 4.67506 4.77417C2.2229 6.86935 1.87767 10.3724 3.80336 12.8504C5.40444 14.9106 10.2499 19.2559 11.838 20.6623C12.0156 20.8196 12.1045 20.8983 12.2081 20.9292C12.2985 20.9562 12.3975 20.9562 12.4879 20.9292C12.5915 20.8983 12.6804 20.8196 12.8581 20.6623C14.4461 19.2559 19.2916 14.9106 20.8926 12.8504C22.8183 10.3724 22.5153 6.84731 20.0209 4.77417C17.5266 2.70104 14.3051 3.29448 12.348 5.58254Z",
    stroke: "#4318ff",
    strokeWidth: 1.46833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.eea67cb8c26904e6a21b6ccc69389f7c.svg";
export { ForwardRef as ReactComponent };